// Product status filter options (aligned with renderColorByString)
export const statusFilters = [
  { key: 'productPage-status', label: 'Pending', value: 'Pending', color: 'rgb(187, 124, 239)' },
  { key: 'productPage-status', label: 'Active', value: 'Active', color: 'rgb(80, 200, 120)' },
  { key: 'productPage-status', label: 'Monthly', value: 'Monthly', color: 'rgb(22, 138, 239)' },
  { key: 'productPage-status', label: 'Expired', value: 'Expired', color: 'rgba(220, 20, 60, 0.9)' },
  { key: 'productPage-status', label: 'Cancelled', value: 'Cancelled', color: 'text.primary' },
  { key: 'productPage-status', label: 'Ended', value: 'Ended', color: 'rgba(220, 20, 60, 0.9)' },
]

// Product category filter options (aligned with renderColorByString)
export const categoryOptions = [
  { key: 'productPage-category', label: 'Creative', value: 'Creative', color: 'rgb(165, 147, 255)' },
  { key: 'productPage-category', label: 'SEO', value: 'SEO', color: 'rgb(238, 111, 141)' },
  { key: 'productPage-category', label: 'Website', value: 'Website', color: 'rgb(129, 82, 223)' },
  { key: 'productPage-category', label: 'Hosting', value: 'Hosting', color: 'rgb(121, 175, 253)' },
  { key: 'productPage-category', label: 'Digital', value: 'Digital', color: 'rgb(51, 211, 145)' },
]

// Product subcategory filter options (aligned with renderColorByString)
export const subcategoryOptions = [
  // Search/Social/Display
  { key: 'productPage-subcategory', label: 'Search', value: 'Search', color: 'rgb(213, 197, 103)' },
  { key: 'productPage-subcategory', label: 'Social', value: 'Social', color: 'rgb(121, 175, 253)' },
  { key: 'productPage-subcategory', label: 'Display', value: 'Display', color: 'rgb(51, 158, 205)' },
  { key: 'productPage-subcategory', label: 'Social Ads', value: 'Social Ads', color: 'rgb(51, 211, 145)' },
  { key: 'productPage-subcategory', label: 'Display Ads', value: 'Display Ads', color: 'rgb(253, 188, 100)' },
  { key: 'productPage-subcategory', label: 'Video Ads', value: 'Video Ads', color: 'rgb(255, 123, 208)' },
  // Creative types
  { key: 'productPage-subcategory', label: 'Logo Design', value: 'Logo Design', color: 'rgb(51, 158, 205)' },
  { key: 'productPage-subcategory', label: 'Design Materials', value: 'Design Materials', color: 'rgb(51, 158, 205)' },
  { key: 'productPage-subcategory', label: 'Photography', value: 'Photography', color: 'rgb(255, 213, 51)' },
  { key: 'productPage-subcategory', label: 'Video', value: 'Video', color: 'rgb(255, 123, 208)' },
  { key: 'productPage-subcategory', label: 'Website Build', value: 'Website Build', color: 'rgb(121, 175, 253)' },
  { key: 'productPage-subcategory', label: 'Website Edits', value: 'Website Edits', color: 'rgb(201, 92, 118)' },
  // Tiers
  { key: 'productPage-subcategory', label: 'Standard', value: 'Standard', color: 'rgb(165, 147, 255)' },
  { key: 'productPage-subcategory', label: 'Premium', value: 'Premium', color: 'rgb(246, 90, 252)' },
  { key: 'productPage-subcategory', label: 'ECommerce', value: 'ECommerce', color: 'rgb(233, 148, 30)' },
]

// Service name (productName) filter options
export const serviceNameOptions = [
  // Paid Media
  {
    key: 'productPage-productName',
    label: 'Paid Search Advertising',
    value: 'Paid Search Advertising',
    color: 'rgb(66, 133, 244)',
  },
  {
    key: 'productPage-productName',
    label: 'Google Display Advertising',
    value: 'Google Display Advertising',
    color: 'rgb(52, 168, 83)',
  },
  { key: 'productPage-productName', label: 'Meta Advertising', value: 'Meta Advertising', color: 'rgb(24, 119, 242)' },
  {
    key: 'productPage-productName',
    label: 'YouTube Advertising',
    value: 'YouTube Advertising',
    color: 'rgb(255, 0, 0)',
  },
  {
    key: 'productPage-productName',
    label: 'Amazon Advertising',
    value: 'Amazon Advertising',
    color: 'rgb(255, 153, 0)',
  },
  {
    key: 'productPage-productName',
    label: 'Microsoft Advertising',
    value: 'Microsoft Advertising',
    color: 'rgb(0, 120, 215)',
  },
  {
    key: 'productPage-productName',
    label: 'LinkedIn Advertising',
    value: 'LinkedIn Advertising',
    color: 'rgb(0, 119, 181)',
  },
  { key: 'productPage-productName', label: 'TikTok Advertising', value: 'TikTok Advertising', color: 'rgb(0, 0, 0)' },
  {
    key: 'productPage-productName',
    label: 'SnapChat Advertising',
    value: 'SnapChat Advertising',
    color: 'rgb(255, 252, 0)',
  },
  {
    key: 'productPage-productName',
    label: 'Spotify Advertising',
    value: 'Spotify Advertising',
    color: 'rgb(30, 215, 96)',
  },
  {
    key: 'productPage-productName',
    label: 'Reddit Advertising',
    value: 'Reddit Advertising',
    color: 'rgb(255, 69, 0)',
  },
  // Programmatic
  {
    key: 'productPage-productName',
    label: 'Programmatic Display',
    value: 'Programmatic Display Advertising',
    color: 'rgb(156, 39, 176)',
  },
  {
    key: 'productPage-productName',
    label: 'Programmatic Video',
    value: 'Programmatic Video Advertising',
    color: 'rgb(233, 30, 99)',
  },
  {
    key: 'productPage-productName',
    label: 'Programmatic Audio',
    value: 'Programmatic Audio Advertising',
    color: 'rgb(103, 58, 183)',
  },
  {
    key: 'productPage-productName',
    label: 'Simplifi Advertising',
    value: 'Simplifi Advertising',
    color: 'rgb(0, 188, 212)',
  },
  // SEO
  { key: 'productPage-productName', label: 'SEO - Tier 1', value: 'SEO - Tier 1', color: 'rgb(238, 111, 141)' },
  { key: 'productPage-productName', label: 'SEO - Tier 2', value: 'SEO - Tier 2', color: 'rgb(238, 111, 141)' },
  { key: 'productPage-productName', label: 'SEO - Tier 3', value: 'SEO - Tier 3', color: 'rgb(238, 111, 141)' },
  { key: 'productPage-productName', label: 'SEO - Tier 4', value: 'SEO - Tier 4', color: 'rgb(238, 111, 141)' },
  // Website & Hosting
  { key: 'productPage-productName', label: 'Website Hosting', value: 'Website Hosting', color: 'rgb(121, 175, 253)' },
  {
    key: 'productPage-productName',
    label: 'Standard Website Build',
    value: 'Standard Website Build',
    color: 'rgb(129, 82, 223)',
  },
  {
    key: 'productPage-productName',
    label: 'Website Revisions',
    value: 'Website Revisions',
    color: 'rgb(201, 92, 118)',
  },
  // Creative
  {
    key: 'productPage-productName',
    label: 'Graphic Design - General',
    value: 'Graphic Design - General',
    color: 'rgb(165, 147, 255)',
  },
  { key: 'productPage-productName', label: 'Photo Shoot', value: 'Photo Shoot', color: 'rgb(255, 213, 51)' },
  { key: 'productPage-productName', label: 'Video Shoot', value: 'Video Shoot', color: 'rgb(255, 123, 208)' },
  { key: 'productPage-productName', label: 'Video Editing', value: 'Video Editing', color: 'rgb(255, 123, 208)' },
  // Fees & Other
  {
    key: 'productPage-productName',
    label: 'Management Fee / Retainer',
    value: 'Management Fee / Retainer',
    color: 'rgb(158, 158, 158)',
  },
  { key: 'productPage-productName', label: 'Consulting', value: 'Consulting', color: 'rgb(96, 125, 139)' },
]

// Deal status filter options for products grid
export const dealStatusOptions = [
  {
    key: 'productPage-dealStatus',
    label: 'Month To Month',
    value: 'Month To Month',
    color: 'rgb(22, 138, 239)',
  },
  {
    key: 'productPage-dealStatus',
    label: 'Active',
    value: 'Active',
    color: 'rgb(80, 200, 120)',
  },
  {
    key: 'productPage-dealStatus',
    label: 'In Progress',
    value: 'In Progress',
    color: 'rgb(253, 188, 100)',
  },
  {
    key: 'productPage-dealStatus',
    label: '30 Day Notice',
    value: '30 Day Notice',
    color: 'rgb(255, 123, 208)',
  },
  {
    key: 'productPage-dealStatus',
    label: 'Replaced',
    value: 'Replaced',
    color: 'rgb(239, 195, 124)',
  },
  {
    key: 'productPage-dealStatus',
    label: 'Pending',
    value: 'Pending',
    color: 'rgb(187, 124, 239)',
  },
  { key: 'dealPage-cancelled', label: 'Cancelled', value: 'Cancelled', color: 'text.primary' },
  {
    key: 'productPage-dealStatus',
    label: 'Ended',
    value: 'Ended',
    color: 'rgba(220, 20, 60, 0.8)',
  },
]
